"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import Link from "@/components/ui/Link";
import { TrailingTag } from '@/components/ui/TrailingTag';
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  tag?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  aspectRatio?: string;
  imageMetadata?: ImageMetadata;
};
export const VerticalMediamTagNews = t0 => {
  const $ = _c(27);
  const {
    title: t1,
    tag: t2,
    imageSrc: t3,
    slug,
    aspectRatio: t4,
    imageMetadata
  } = t0;
  let t5;
  if ($[0] !== t1) {
    t5 = t1 === undefined ? {
      hidden: false,
      value: "\u0B9C\u0BC6\u0B95\u0BA4\u0BC0\u0BB7\u0BCD \u0BB7\u0BC6\u0B9F\u0BCD\u0B9F\u0BB0\u0BCD",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const title = t5;
  let t6;
  if ($[2] !== t2) {
    t6 = t2 === undefined ? {
      hidden: false,
      value: "Leading",
      customClass: "bg-22C55E"
    } : t2;
    $[2] = t2;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const tag = t6;
  let t7;
  if ($[4] !== t3) {
    t7 = t3 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const imageSrc = t7;
  t4 === undefined ? "16 / 9" : t4;
  const titleValue = title?.value || "";
  let t8;
  if ($[6] !== imageSrc?.value) {
    t8 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[6] = imageSrc?.value;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const imageSrcValue = t8;
  const tagValue = tag?.value || "Leading";
  const tagColor = tag?.customClass || "bg-22C55E";
  let t9;
  if ($[8] !== imageMetadata || $[9] !== imageSrc?.customClass || $[10] !== imageSrc?.hidden || $[11] !== imageSrcValue || $[12] !== tag?.hidden || $[13] !== tagColor || $[14] !== tagValue || $[15] !== titleValue) {
    t9 = !imageSrc?.hidden && <div className="relative w-full"><div className={`relative w-full overflow-hidden rounded-t-xl ${imageSrc?.customClass || ""}`} style={{
        aspectRatio: "1 / 1"
      }}><Image src={imageSrcValue} alt={titleValue} fill={true} sizes="(max-width: 768px) 40vw, 160px" className="object-cover" style={getFocusPointStyle(imageMetadata)} loading="lazy" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /><div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-333333 to-transparent" /></div>{!tag?.hidden && <div className="absolute top-2 right-2"><TrailingTag id="trial" label={tagValue} color={tagColor} /></div>}</div>;
    $[8] = imageMetadata;
    $[9] = imageSrc?.customClass;
    $[10] = imageSrc?.hidden;
    $[11] = imageSrcValue;
    $[12] = tag?.hidden;
    $[13] = tagColor;
    $[14] = tagValue;
    $[15] = titleValue;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== title?.customClass || $[18] !== title?.hidden || $[19] !== titleValue) {
    t10 = !title?.hidden && <div className={`text-center px-3 pb-3 -mt-1 ${title?.customClass || ""}`}><div className="text-14-tamil-500 text-white">{titleValue}</div></div>;
    $[17] = title?.customClass;
    $[18] = title?.hidden;
    $[19] = titleValue;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = <div className="flex flex-col items-center overflow-hidden min-w-[130px] bg-333333 rounded-xl">{t9}{t10}</div>;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const content = t11;
  if (slug) {
    const t12 = `/${slug}`;
    let t13;
    if ($[24] !== content || $[25] !== t12) {
      t13 = <Link href={t12} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[24] = content;
      $[25] = t12;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    return t13;
  }
  return content;
};